import requests from "./httpServices";
import { showErrorAlert } from "./AlertService";

const UnsubscribeService = {
    unsubscribe: async (email, timestamp, userAgent) => {
        try {
            const response = await requests.post('/unsubscribe', {
                email: email,
                timestamp: timestamp || new Date().toISOString(),
                userAgent: userAgent || navigator.userAgent
            });
            return response;
        } catch (error) {
            console.error('Unsubscribe service error:', error);
            showErrorAlert(error);
            throw error;
        }
    }
};

export default UnsubscribeService;
